import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { IdentityService } from './identity.service';

export const checkRouteClaims: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const identityService = inject(IdentityService);

  const claim: string = route.data ? (route.data.expectedClaim as string) : '';

  if (!identityService.isLogged$.getValue()) {
    void inject(Router).navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // Se la route non ha un claim, è navigabile
  if (typeof claim === 'undefined' || claim === null || claim === '') {
    return true;
  }

  // Se è specificato un claim controllo che l'utente lo abbia
  // I claim possono essere più di uno, es.: claim1,claim2:valore2,claim3:valore3
  const claims = claim.split(',');
  if (claims.length > 0) {
    let res = false;
    for (const value of claims) {
      const claimData = value.split(':');
      if (claimData.length > 1) {
        res = identityService.hasClaim(claimData[0], claimData[1]);
      } else {
        res = identityService.hasClaim(value);
      }

      if (res) return true;
    }
  }

  return false;
};

